module.exports = __webpack_public_path__ + "static/img/01.5ce9b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/01.jpg
// module id = kxjO
// module chunks = 0